import { api } from "@/lib/api-client"

export type AssignedVisitStatus = "not_yet_seen" | "inactive" | "history_unknown" | "recent"

export type AssignedVisitUser = {
  userId: string
  name: string
  email: string
  groupValue: string
  assignedAt: string | null
  lastVisitAt: string | null
  status: Exclude<AssignedVisitStatus, "recent">
}

export type AssignedVisitsResponse = {
  days: number
  trackingStartedAt: string
  asOf: string
  totalAssigned: number
  counts: Record<AssignedVisitStatus, number>
  users: AssignedVisitUser[]
  groupValue?: string
}

export async function getAdminAssignedVisits(days: number): Promise<AssignedVisitsResponse> {
  const response = await api.get(`/admin/local-ai-lead-assigned-visits?days=${days}`)
  return response.data || response
}

export async function getLeadAssignedVisits(
  days: number,
  groupValue: string
): Promise<AssignedVisitsResponse> {
  const query = new URLSearchParams({ days: String(days), groupValue })
  const response = await api.get(`/local-ai-lead/assigned-visits?${query}`)
  return response.data || response
}

export async function enableAssignedVisits(): Promise<{
  enabled: boolean
  trackingStartedAt: string
}> {
  const response = await api.post("/admin/local-ai-lead-assigned-visits/enable", {})
  return response.data || response
}
